<template>
  <v-app-bar
    app
    flat
    height="72"
    dark
    v-bind="$attrs"
  >
    <DrawerToggler drawer='main-navigation'/>
    <CPULogo height="20px" class="mr-2" />
    <v-toolbar-title>
      <portal-target name="module-title" tag="span" />
    </v-toolbar-title>
    <v-spacer></v-spacer>
    <portal-target name="app-bar-right" multiple />
  </v-app-bar>
</template>

<script>
import CPULogo from '@/components/common/CPULogo.vue'
import DrawerToggler from '@/components/common/DrawerToggler.vue'

export default {
  name: 'AppBar',
  components: {
    DrawerToggler,
    CPULogo
  },
  data: () => ({})
}
</script>
